import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import { Avatar, Button, Drawer, Spin, Tag } from "antd";
import PropTypes from "prop-types";

import { CloseOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const ActiveLog = ({ recordId, type, open, onClose }) => {
  console.log(type);

  const [activityLog, setActivityLog] = useState([]);

  console.log(activityLog, "activityyyyyyyyyyy");
  const [activityLoading, setActivityLoading] = useState(false);
  const getActivityLog = async () => {
    try {
      setActivityLoading(true);

      const activityApiMap = {
        proposal: "proposal/GetProposalActivitylog",
        estimate: "estimates/GetEstimateActivitylog",
        invoice: "invoice/GetInvoiceActivitylog",
        creditnote: "creditnotes/GetCreditNoteActivitylog",
      };

      const endpoint = activityApiMap[type];

      if (!endpoint || !recordId) {
        setActivityLog([]);
        return;
      }

      const response = await axios.get(
        `${BASE_CRM_URL}${endpoint}?${
          type === "estimate"
            ? "EstimateId"
            : type === "proposal"
            ? "ProposalId"
            : type === "invoice"
            ? "InvoiceId"
            : "CreditNoteId"
        }=${recordId}`
      );

      if (response.data.Status) {
        setActivityLog(response.data.ResultData || []);
      } else {
        setActivityLog([]);
      }
    } catch (error) {
      console.error("Error fetching activity log:", error);
      setActivityLog([]);
    } finally {
      setActivityLoading(false);
    }
  };

  useEffect(() => {
    if (recordId && type) {
      getActivityLog();
    }
  }, [recordId, type]);
  return (
    <Drawer
      title="Activity Log"
      placement="right"
      width={550}
      open={open}
      onClose={onClose}
      destroyOnClose
      maskClosable={true}
      closable={false}
      extra={<Button type="text" icon={<CloseOutlined />} onClick={onClose} />}
    >
      {activityLoading ? (
        <div className="text-center py-5">
          <Spin size="large" />
        </div>
      ) : activityLog ? (
        <div className="activity-log">
          {/* User Information */}
          <div className="border rounded p-3 mb-3">
            <div className="d-flex align-items-center">
              <Avatar size={55} />

              <div className="ms-3">
                <h6 className="mb-1 fw-bold">
                  {activityLog.StaffName || "Unknown User"}
                </h6>

                <div className="text-muted">
                  <i className="fa-regular fa-calendar me-2"></i>
                  {activityLog.date
                    ? dayjs(activityLog.date).format("DD MMM YYYY")
                    : "-"}
                </div>

                <div className="text-muted">
                  <i className="fa-regular fa-clock me-2"></i>
                  {activityLog.date
                    ? dayjs(activityLog.date).format("hh:mm A")
                    : "-"}
                </div>
              </div>
            </div>
          </div>

          {/* Activity Details */}
          <div className="border rounded p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <Tag color="green">Activity</Tag>

              {/* Optional ID */}
              {/* <span className="text-muted">
      #{activityLog.id}
    </span> */}
            </div>

            <h6 className="fw-semibold mb-0">
              {activityLog.description || "No activity description"}
            </h6>
          </div>
        </div>
      ) : (
        <div className="text-center text-muted py-5">No activity found</div>
      )}
    </Drawer>
  );
};
ActiveLog.propTypes = {
  recordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
export default ActiveLog;
